import React, { useEffect, useState } from "react";
import "../Components/Businesscardpage.css";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import img1 from "../Components/images/busineshandimage_e699f4b.png";
import img2 from "../Components/images/arabScreenshot (162).png";
import CircularProgress from "@mui/material/CircularProgress";
import AOS from "aos";
import "aos/dist/aos.css";

const Businesscardpage = () => {
  const navigate = useNavigate();
  const [Businesspageservices, setBusinesspageServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const headerData = Businesspageservices?.[0] || {};
  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);

        const q = query(
          collection(db, "ownerPageDatas"),
          where("selectedmenutype", "==", "Businesspage")
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setBusinesspageServices(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);
   useEffect(() => {
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
      });
    }, []);

 // 👇 Loader here
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress size={60} sx={{ color: "#45B2F7" }} />
      </div>
    );
  }
  return (
    <div>
      {/* HERO SECTION */}
      <div
        className="mainhero-container"
        style={{
          backgroundImage: `url(${headerData?.headerimage || img1})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="mainhero-content">
          <h1>
            <span style={{ color: "#45B2F7" }}>
              {headerData?.headerTitle?.split(" ")[0] || "MAS"}
            </span>{" "}
            {headerData?.headerTitle?.split(" ").slice(1).join(" ") ||
              "Mobility Service"}
          </h1>

          <p>
            {headerData?.headerDescription ||
              "MAS Mobility Service provides professional transportation solutions for businesses and corporate clients throughout Jeddah."}
          </p>

          <button
            style={{
              marginTop: "20px",
              padding: "14px 30px",
              backgroundColor: "blue",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "600",
              cursor: "pointer",
            }}
            onClick={() => navigate("/contact")}
          >
            Become a Partner
          </button>
        </div>
      </div>

      {/* FEATURE SECTION */}
      <section className="business-features">
        <div className="feature-container">
          <div className="feature-card">
            <img
              src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d"
              alt=""
            />
            <h3>Drive Booking</h3>
            <p>
              Through the business booking portal, your team can easily
              schedule rides with complete flexibility and control.
            </p>
          </div>

          <div className="feature-card">
            <img
              src="https://images.unsplash.com/photo-1498050108023-c5249f4df085"
              alt=""
            />
            <h3>Booking Management</h3>
            <p>
              Simplify team transportation with centralized control of all
              corporate bookings.
            </p>
          </div>

          <div className="feature-card">
            <img
              src="https://images.unsplash.com/photo-1503376780353-7e6692767b70"
              alt=""
            />
            <h3>Seamless Experience</h3>
            <p>
              Enjoy a premium, stress-free transportation experience for your
              employees and clients.
            </p>
          </div>
        </div>
      </section>

      {/* EMPLOYEE SECTION */}
   <div>
        {loading ? (
          <div className="skeleton-card">loading ....</div>
        ) : Businesspageservices?.length === 0 ? (
          <h2 style={{ textAlign: "center" }}>No data found</h2>
        ) : (
          Businesspageservices?.map((service, index) => (
            <div
              key={service.id}
              className={`service-section ${index % 2 !== 0 ? "reverse" : ""
                }`}
            >
              {/* IMAGE */}
              <div
                className="service-image"
                data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
              >
                <img src={service?.image || img2} alt={service.description} />
              </div>

              {/* CONTENT */}
              <div className="service-content">
                <h2>{service.description}</h2>

                <ul className="service-list-business">
                  {service?.content
                    ?.split(".")
                    .filter((item) => item.trim() !== "")
                    .map((item, index) => (
                      <li key={index}>
                        
                        {item.trim()}
                      </li>
                    ))}
                </ul>
              </div>

            </div>
          ))
        )}
      </div>


    

      {/* CTA SECTION */}
      <section className="business-cta">
        <h2>Looking for a Reliable Business Partner?</h2>

        <p>
          Let MAS Mobility Service handle your company transportation with
          professionalism, reliability, and comfort.
        </p>

        <button
          className="primary-btn"
          onClick={() => navigate("/contact")}
        >
          Request a Quote
        </button>
      </section>
    </div>
  );
};

export default Businesscardpage;